<template>
	<div class="certificate-list">
		<b-row class="mb-3">
			<b-col cols="3">
				<multiselect
					v-model="filter.departmentId"
					:options="listWarehouse"
					:multiple="false"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>
			<b-col cols="2">
				<b-form-input id="name"
							  v-model="filter.name"
							  name="name"
							  :placeholder="$t('section.create-section-type.name') +'/'+ $t('goods.artikul')"
							  :disabled="disabled"
							  v-on:keyup.enter="accept"

				>
				</b-form-input>
			</b-col>
			<b-col cols="2">
				<b-form-input id="barcode"
							  v-model="filter.barCode"
							  name="barcode"
							  :placeholder="$t('goods.barcode')"
							  :disabled="disabled"
							  v-on:keyup.enter="accept"
				>
				</b-form-input>
			</b-col>
			<b-col cols="2">
				<b-form-select
					v-model="filter.brand"
					:disabled="disabled"

				>
					<option v-for="(selectOption, indexOpt) in brands"
							:key="indexOpt"
							:value="selectOption.id"
					>
						{{ selectOption.name }}
					</option>
					<template slot="first">
						<option :value="null">-- {{$t('goods.brand')}} --</option>
					</template>
				</b-form-select>

			</b-col>
			<b-col><b-button @click="accept" :disabled="loading" class="pull-right" variant="primary">{{ $t('apply') }}
				</b-button></b-col>
		</b-row>

		<!--<b-col :cols="companyType === 'SHOP' ? 3 : 2" v-if="companyType !== 'SHOP' ">-->
		<!--<b-form-select-->
		<!--v-model="filter.category"-->
		<!--:options="allCategory"-->
		<!--value-field="id"-->
		<!--text-field="name"-->
		<!--:disabled="disabled"-->
		<!--@change="categorySelected"-->
		<!--&gt;-->
		<!--<template slot="first">-->
		<!--<option value="all">&#45;&#45; Все Категории &#45;&#45;</option>-->
		<!--</template>-->
		<!--</b-form-select>-->
		<!--</b-col>-->
		<!--<b-col :cols="companyType === 'SHOP' ? 3 : 2">-->
		<!--<b-form-select-->
		<!--v-model="subcategory.value"-->
		<!--:disabled="subcategory.isDisabled"-->
		<!--@change="subCategorySelected"-->

		<!--&gt;-->
		<!--<option v-for="(selectOption, indexOpt) in subcategory.items"-->
		<!--:key="indexOpt"-->
		<!--:value="selectOption.id"-->
		<!--&gt;-->
		<!--{{ selectOption.name }}-->
		<!--</option>-->
		<!--<template slot="first">-->
		<!--<option :value="null">&#45;&#45; {{ companyType === 'SHOP' ? $t('client.create.customer') : 'Все Подкатегории'}} &#45;&#45;</option>-->
		<!--</template>-->
		<!--</b-form-select>-->

		<!--</b-col>-->
		<!--<b-col :cols="companyType === 'SHOP' ? 3 : 2">-->
		<!--<b-form-select-->
		<!--v-model="subsubcategory.value"-->
		<!--:disabled="subsubcategory.isDisabled"-->
		<!--@change="subsubCategorySelected"-->

		<!--&gt;-->
		<!--<option v-for="(selectOption, indexOpt) in subsubcategory.items"-->
		<!--:key="indexOpt"-->
		<!--:value="selectOption.id"-->
		<!--&gt;-->
		<!--{{ selectOption.name }}-->
		<!--</option>-->
		<!--<template slot="first">-->
		<!--<option :value="null">&#45;&#45; {{ companyType === 'SHOP' ? $t('client.create.category') : 'Все Подкатегории'}} &#45;&#45;-->
		<!--</option>-->
		<!--</template>-->
		<!--</b-form-select>-->

		<!--</b-col>-->
		<!--<b-col :cols="companyType === 'SHOP' ? 3 : 2">-->
		<!--<b-form-select-->
		<!--v-model="sub3category.value"-->
		<!--:disabled="sub3category.isDisabled"-->

		<!--&gt;-->
		<!--<option v-for="(selectOption, indexOpt) in sub3category.items"-->
		<!--:key="indexOpt"-->
		<!--:value="selectOption.id"-->
		<!--&gt;-->
		<!--{{ selectOption.name }}-->
		<!--</option>-->
		<!--<template slot="first">-->
		<!--<option :value="null">&#45;&#45; {{ companyType === 'SHOP' ? $t('goods.subcategory') : 'Все Подкатегории'}} &#45;&#45;-->
		<!--</option>-->
		<!--</template>-->
		<!--</b-form-select>-->
		<!--</b-col>-->


		<!--<b-row class="mb-3">-->


		<!--<b-col cols="2">-->
		<!--<b-input-group>-->
		<!--<masked-input v-model="filter.start"-->
		<!--mask="11-11-1111"-->
		<!--class="ml-1 form-control form-control-sm"-->
		<!--:placeholder=" $t('warehouse.date.start')"-->
		<!--:disabled="disabled"-->
		<!--size="sm"-->

		<!--/>-->
		<!--<b-input-group-addon>-->
		<!--<b-input-group-text>-->
		<!--<i class="fa fa-calendar"></i>-->
		<!--</b-input-group-text>-->
		<!--</b-input-group-addon>-->
		<!--</b-input-group>-->
		<!--</b-col>-->
		<!--<b-col cols="2">-->
		<!--<b-input-group>-->
		<!--<masked-input v-model="filter.end"-->
		<!--mask="11-11-1111"-->
		<!--class="ml-1 form-control form-control-sm"-->
		<!--:placeholder=" $t('warehouse.date.end')"-->
		<!--:disabled="disabled"-->
		<!--size="sm"-->
		<!--/>-->
		<!--<b-input-group-addon>-->
		<!--<b-input-group-text>-->
		<!--<i class="fa fa-calendar"></i>-->
		<!--</b-input-group-text>-->
		<!--</b-input-group-addon>-->
		<!--</b-input-group>-->
		<!--</b-col>-->
		<!--<b-col cols="2" v-if="companyType === 'SHOP' || categoryCode === 'MAGAZIN'">-->
		<!--<b-form-select-->
		<!--v-model="filter.gender"-->
		<!--:disabled="disabled"-->


		<!--&gt;-->
		<!--<option v-for="(selectOption, indexOpt) in genders"-->
		<!--:key="indexOpt"-->
		<!--:value="selectOption.id"-->
		<!--&gt;-->
		<!--{{ selectOption.name }}-->
		<!--</option>-->
		<!--<template slot="first">-->
		<!--<option :value="null">&#45;&#45; Пол &#45;&#45;</option>-->
		<!--</template>-->
		<!--</b-form-select>-->

		<!--</b-col>-->


		<!--</b-row>-->
		<!--<b-row>-->
		<!--<b-col cols="3">-->
		<!--<multiselect-->
		<!--v-model="colors.value"-->
		<!--:options="colors.items"-->
		<!--track-by="id"-->
		<!--:show-labels="false"-->
		<!--:allow-empty="true"-->
		<!--label="name"-->
		<!--:placeholder="$t('goods.create.color')"-->
		<!--class="multiselect-pricing"-->
		<!--&gt;-->
		<!--</multiselect>-->
		<!--</b-col>-->
		<!--</b-row>-->
		<!-- <b-row>
			<b-col>

			</b-col>
		</b-row> -->


		<hr>
	</div>
</template>

<script>
	import Multiselect from 'vue-multiselect'
	import MaskedInput from 'vue-masked-input'
	import ReferencesService from "../../../services/references.sevice";
	import {TokenService} from "../../../services/storage.service";

	export default {
		name: 'Filter-Warehouse',

		props: {
			departments: {
				type: Array,
				default: []
			},
			loading: {
				type: Boolean,
				default: null
			},
		},
		components: {MaskedInput, Multiselect},
		data() {
			return {
				filter: {
					departmentId: null,
					start: '',
					end: '',
					depsId: [],
					barCode: null,
					name: null,
					category: 'all',
					gender: null,
					brand: null,
				},
				subcategory: {
					items: [],
					value: null,
					isDisabled: true,
				},
				subsubcategory: {
					items: [],
					value: null,
					isDisabled: true,
				},
				sub3category: {
					items: [],
					value: null,
					isDisabled: true,
				},
				colors: {
					items: [],
					value: null
				},
				companyType: '',
				allCategory: [],
				categoryCode: null,
				disabled: true,
				brands: [],
				genders: [],
				attr: {},
			}
		},

		mounted() {

			// setTimeout(() => {
			// 	if (this.departments.length > 0) {
			// 	this.filter.departmentId = this.listWarehouse[0].id
			// 	}
			// }, 200)

		},

		watch: {
			'filter.departmentId': {
				async handler(newVal) {
					await this.$store.commit('departments/setFromDepId', newVal.id);
					if (Object.keys(this.filter.departmentId).length !== 0) {
						this.setCompanyType()
						if (this.companyType === 'SHOP') {
							this.subcategory.isDisabled = false
						}
						this.disabled = false

					} else {
						this.disabled = true
						if (this.companyType !== 'SHOP') {
							this.filter.category = 'all'
							this.categoryCode = null;
						}
						this.subcategory.value = null
						this.subsubcategory.value = null
						this.sub3category.value = null

						this.sub3category.isDisabled = true
						this.subcategory.isDisabled = true
						this.subsubcategory.isDisabled = true
					}
				}
			},
			'filter.category': {
				handler(newValue) {
					if (newValue === 'all') {
						this.subcategory.value = null
						this.subsubcategory.value = null
						this.sub3category.value = null
					}

				}
			},

		},

		computed: {
			listWarehouse() {
				return this.departments.filter(item => {
					if(!item.saleType) {
						item.$isDisabled = true
					}
					return item;
				})
			}
		},
		methods: {
			async loadColors() {
				let response = await ReferencesService.getReferenceChildren(`color`);
				this.colors.items = response.data;

			},


			accept() {
				if (this.filter.departmentId !== null && Object.keys(this.filter.departmentId).length !== 0) {
					this.setFilterToComponent()
					this.$emit('myEvent')
				} else {
					this.$vs.notify({
						title: 'Пожалуйста выберите Отдел',
						color: 'warning',
						icon: 'close',
						position: 'top-right'
					});
				}
			},
			async loadCategory() {
				await ReferencesService.getReferenceChildren(`WAREHOUSE_CATEGORY`).then(response => {
					this.allCategory = response.data;
				})
			},
			/**+
			 * Load genders
			 */
			loadGenders() {
				ReferencesService.getReferenceChildren('GENDER').then(response => {
					this.genders = response.data;
				})
			},
			loadBrands() {
				ReferencesService.getReferenceChildren(`item_brand`).then(response => {
					this.brands = response.data;
				})
			},
			setFilterToComponent() {
				this.filter.depsId = []
				let depNames = []
				if (this.filter.departmentId) {
					if (Object.keys(this.filter.departmentId).length !== 0) {
						// this.filter.departmentId.forEach(item => {
							this.filter.depsId.push(this.filter.departmentId.id)
							let tempForCurrency = {
								name: this.filter.departmentId.name,
								currencyName: this.filter.departmentId.currencyName
							}

							depNames.push(tempForCurrency)
						// })
						let dataCustom = {
							page: 1,
							limit: 50,
							depIds: this.filter.depsId
						}
						this.disabled = false
						this.attr['departmentId'] = 10;
						this.attr['empty'] = false
						this.attr['depNames'] = depNames
						this.attr['depsId'] = dataCustom


						let str = "?depIds=" + this.filter.depsId +
							"&catId=" + this.filter.category +
							"&start=" + `${this.filter.start !== '' && this.filter.start !== '__-__-____' ? this.filter.start : null}` +
							"&end=" + `${this.filter.end !== '' && this.filter.end !== '__-__-____' ? this.filter.end : null}` +
							"&barcode=" + `${this.filter.barCode !== '' ? this.filter.barCode : null}` +
							"&name=" + `${this.filter.name !== '' ? this.filter.name : null}` +
							"&subId=" + `${this.subcategory.value !== null ? this.subcategory.value : null}` +
							"&sub2Id=" + `${this.subsubcategory.value !== null ? this.subsubcategory.value : null}` +
							"&sub3Id=" + `${this.sub3category.value !== null ? this.sub3category.value : null}` +
							"&genderId=" + `${this.filter.gender !== null ? this.filter.gender : null}` +
							"&brandId=" + `${this.filter.brand !== null ? this.filter.brand : null}` +
							"&colorId=" + `${this.colors.value ? this.colors.value.id : null}`

						this.attr['link'] = str

						this.$emit('filter', this.attr);


					} else {

						this.disabled = true
						this.filter.category = 'all'
						this.subcategory.isDisabled = true
						this.subcategory.value = null
						this.subsubcategory.isDisabled = true
						this.subsubcategory.value = null
						this.attr['empty'] = true
						this.attr['departmentId'] = 10;
						this.filter.depsId = []

						this.attr['depNames'] = [];
						this.attr['departments'] = [];
						this.attr['depsId'] = [];
						this.attr['depsId'] = [];
						this.$emit('filter', this.attr);
					}
				} else {
					this.disabled = true
					this.filter.category = 'all'
					this.subcategory.isDisabled = true
					this.subcategory.value = null
					this.subsubcategory.isDisabled = true
					this.subsubcategory.value = null
					this.attr['empty'] = true
					this.attr['departmentId'] = 10;
					this.$emit('filter', this.attr);
					this.filter.depsId = []
					depNames = []
				}
			},
			setCategoryCode(value) {
				this.allCategory.filter(el => {
					if (el.id === value) {
						this.categoryCode = el.code
					}
				})
			},
			loadSubCategory(id) {
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.subcategory.items = response.data;
				})
			},
			loadSubSubCategory(id) {
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.subsubcategory.items = response.data;
				})
			},
			loadSub3Category(id) {
				ReferencesService.getSubReferenceChildren(id).then(response => {
					this.sub3category.items = response.data;
				})
			},

			categorySelected() {

				if (this.filter.category !== 'all') {
					this.subcategory.isDisabled = false
					this.loadSubCategory(this.filter.category)
					this.subcategory.isDisabled = false
					this.subcategory.value = null

				} else {
					this.subcategory.isDisabled = true
					this.subcategory.value = null

				}

				this.setCategoryCode(this.filter.category);
				this.subsubcategory.isDisabled = true
				this.subsubcategory.value = null
				this.sub3category.isDisabled = true
				this.sub3category.value = null

			},
			subCategorySelected() {

				if (this.subcategory.value !== null) {
					this.subsubcategory.isDisabled = false
					this.subsubcategory.value = null
					this.loadSubSubCategory(this.subcategory.value)
				} else {
					this.subsubcategory.isDisabled = true
					this.subsubcategory.value = null

				}
				this.sub3category.isDisabled = true
				this.sub3category.value = null

			},
			subsubCategorySelected() {

				if (this.subsubcategory.value !== null) {
					this.sub3category.isDisabled = false
					this.sub3category.value = null
					this.loadSub3Category(this.subsubcategory.value)
				} else {
					this.sub3category.isDisabled = true
					this.sub3category.value = null

				}

			},

			setCompanyType() {
				this.companyType = TokenService.getDepartmentType()
				if (this.companyType === 'SHOP') {
					this.allCategory.filter(el => {
						if (el.code === 'MAGAZIN') {
							this.filter.category = el.id
						}
					})

					this.loadSubCategory(this.filter.category)
					//this.subcategory.isDisabled = false;
				}

			},

		},
		async created() {
			await this.loadCategory()
			this.setCompanyType();
			this.loadGenders();
			this.loadBrands();
			this.loadColors();
		},

	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.editBtn {
		font-size: 14px;
		cursor: pointer;
	}

	.filter-frame {
		padding-bottom: 15px;
	}

	.slide-enter, .slide-leave-to {
		transform: scaleY(0);
	}

	.certificateGenerate {
		background: transparent !important;
		border: none;
		padding: 7px;
		font-size: 16px;
	}

	.certificateGenerate span {
		margin-left: 5px;
	}

	.top-card {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.search_btn {
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-right: 25px
	}

	input[type=number]::-webkit-inner-spin-button,
	input[type=number]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
</style>
